// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"c93f4e83","671":"f1a33d3f","897":"1b4c976d","911":"137bc0da"}[chunkId] + ".chunk.js";
};